module.exports = __webpack_public_path__ + "img/auscultation-icon.7d72ff0c.png";